import React, { useState, useCallback, useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import ConfirmActionModal from '../modals/deallocate/confirm-action-modal';
import { InventoryContext } from '../inventory-context';

import { deallocateProduct } from '../../../../store/inventory/inventory.api';
import messages from '../../messages';
import style from '../../../../components/grid-header/reusable-grid-button.module.less';

const DeallocateButton = () => {
  const { refreshGridData, selectedProductIds } = useContext(InventoryContext);
  const [shouldRenderModal, setShouldRenderModal] = useState(false);
  const confirmDeallocate = useCallback(() => {
    deallocateProduct(selectedProductIds).promise.then(refreshGridData);
    setShouldRenderModal(false);
  }, [selectedProductIds, refreshGridData]);
  const openConfirmationModal = useCallback(() => {
    setShouldRenderModal(true);
  }, []);
  const onClose = useCallback(() => {
    setShouldRenderModal(false);
  }, []);
  return (
    <>
      <Button
        className={style['reusable-button']}
        disabled={selectedProductIds.length !== 1}
        onClick={openConfirmationModal}
        theme='tertiary'
      >
        <FormattedMessage {...messages.deallocateButton} />
      </Button>
      {shouldRenderModal && (
        <ConfirmActionModal onClose={onClose} onConfirm={confirmDeallocate} selectedProductId={selectedProductIds[0]} />
      )}
    </>
  );
};

export default DeallocateButton;
